const PAGES = {
  NEW_PIN: "NEW_PIN",
  ONE_TIME_CODE: "ONE_TIME_CODE",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

const initialSetPinState = {
  page: PAGES.NEW_PIN,
  sendOtpUrl: null,
  accountInfo: null,
  errorType: null,
  maskedMobileNumber: null,
  encodedPinBlock: null,
  rsaId: null,
  finalisePinChangeAction: null,
  resendOtpAction: null,
};

function setPinReducer(state, action) {
  switch (state.page) {
    case PAGES.NEW_PIN: {
      switch (action.type) {
        case "SEND_OTP_URL_FOUND": {
          return {
            ...state,
            sendOtpUrl: action.sendOtpUrl,
          };
        }

        case "SEND_OTP_URL_NOT_FOUND": {
          return {
            ...state,
            page: PAGES.ERROR,
            errorType: "PIN_CHANGE_NOT_AVAILABLE",
          };
        }

        case "ACCOUNT_INFO_LOADED": {
          return {
            ...state,
            accountInfo: action.accountInfo,
          };
        }

        case "OTP_SENT_AND_PIN_ENCODED": {
          return {
            ...state,
            page: PAGES.ONE_TIME_CODE,
            maskedMobileNumber: action.maskedMobileNumber,
            encodedPinBlock: action.encodedPinBlock,
            rsaId: action.rsaId,
            finalisePinChangeAction: action.finalisePinChangeAction,
            resendOtpAction: action.resendOtpAction,
          };
        }

        case "PIN_ENCODING_FAILED":
        case "SEND_OTP_FAILED":
        case "INVALID_RESPONSE": {
          return {
            ...state,
            page: PAGES.ERROR,
            errorType: "UNEXPECTED_ERROR",
          };
        }

        default: {
          return state;
        }
      }
    }

    case PAGES.ONE_TIME_CODE: {
      switch (action.type) {
        case "ONE_TIME_CODE_VERIFIED_SUCCESSFULLY": {
          return {
            ...state,
            page: PAGES.SUCCESS,
          };
        }

        case "ONE_TIME_CODE_VERIFICATION_FAILED":
        case "ONE_TIME_CODE_RESEND_FAILED": {
          return {
            ...state,
            page: PAGES.ERROR,
            errorType: "UNEXPECTED_ERROR",
          };
        }

        default: {
          return state;
        }
      }
    }

    default: {
      return state;
    }
  }
}

export { PAGES, initialSetPinState, setPinReducer };
